"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencySection = void 0;
var react_1 = __importDefault(require("react"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var SectionHeading_1 = require("../SectionHeading");
var CurrencySelector_1 = require("Project/Actions/ManualPageValue/CurrencySelector");
var Types_1 = require("@CommonFrontendBackend/Account/Types");
var UseAnalyticsAccountSettings_1 = require("../UseAnalyticsAccountSettings");
var UseSaveableState_1 = require("Utils/UseSaveableState");
var CurrencySection = function (_a) {
    var className = _a.className;
    var _b = (0, UseAnalyticsAccountSettings_1.useAnalyticsAccountSettings)(), data = _b.data, updateCurrency = _b.updateCurrency;
    var _c = __read((0, UseSaveableState_1.useSaveableState)(data === null || data === void 0 ? void 0 : data.defaultCurrency, updateCurrency), 4), localState = _c[0], setUnsavedState = _c[1], save = _c[2], _d = _c[3], disableInputs = _d.disableInputs, disableSave = _d.disableSave;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(SectionHeading_1.SectionHeading, { icon: react_1.default.createElement(icons_1.Value, null), headingText: "Default currency filter", description: react_1.default.createElement(kaleidoscope_1.Text, null, "Manage the default currency for Analytics and Reports") }),
        react_1.default.createElement("div", { className: "".concat(className, "__default-currency-selector") },
            react_1.default.createElement(kaleidoscope_1.Label, { className: "".concat(className, "__currency-label"), element: "div", align: "left", size: "s" }, "DEFAULT CURRENCY"),
            react_1.default.createElement(CurrencySelector_1.CurrencySelector, { popoverClassName: "default-account-currency-setting-popover", currentCurrency: localState || Types_1.CurrencyCode.AUD, onChange: function (currency) { return setUnsavedState(Types_1.CurrencyCode[currency]); }, disabled: disableInputs }),
            react_1.default.createElement(kaleidoscope_1.Button, { className: "".concat(className, "__update-button"), onClick: save, size: kaleidoscope_1.ButtonSize.Large, disabled: disableSave }, "Update default currency"))));
};
exports.CurrencySection = CurrencySection;
